import { z } from 'zod'
import { paxtonHighlightAreaSchema } from '@/components/react-pdf-viewer/schema/paxton-highlight-area'

/** Reference types used by analytics reporting. */
export enum AnalyticsReferenceType {
  administrative_decision = 'administrative_decision',
  documentquery = 'documentquery',
  documentquery_full_doc = 'documentquery_full_doc',
  pol = 'pol',
  caselaw = 'caselaw',
  caselaw_v3 = 'caselaw_v3',
  lrr_v2 = 'lrr_v2',
  lrr_v3 = 'lrr_v3',
}

export const AnalyticsReferenceSchema = z.object({
  reference_number: z.string(),
  text: z.string(),
  metadata: z.record(z.any()),
  relevant_sentences: z.array(z.string()).nullable(),
  relevant_highlights: z
    .array(paxtonHighlightAreaSchema)
    .nullable()
    .describe('Highlight bounding box data compatible with react_pdf_viewer highlighting needs and sentence grouping needs'),
})
export type AnalyticsReference = z.infer<typeof AnalyticsReferenceSchema>
